module.exports = __webpack_public_path__ + "img/weather_cloud.661e37f5.png";